import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import _ from 'lodash';

export default class Form extends Component {
    static get propTypes() {
        return {
            validationOptions: PropTypes.object
        };
    }

    form;
    validator;

    componentDidMount() {
        this._createValidator();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.validationOptions, this.props.validationOptions)) {
            this._destroyValidator();
            this._createValidator();
        }
    }

    componentWillUnmount() {
        this._destroyValidator();
    }

    _createValidator() {
        this.validator = $(this.form).validate({...this.props.validationOptions});
        this.validator.checkForm();
    }

    _destroyValidator() {
        if (this.validator) {
            this.validator.resetForm();
            this.validator = null;
        }
    }

    validate() {
        return this.validator.checkForm();
    }

    render() {
        // eslint-disable-next-line no-unused-vars
        const {validationOptions, ...formProps} = this.props;

        return (
            <form ref={el => this.form = el} action="" method="POST" {...formProps}/>
        );
    }
}
